import { render } from "./PostSprite.vue?vue&type=template&id=5e02990d"
import script from "./PostSprite.vue?vue&type=script&lang=js"
export * from "./PostSprite.vue?vue&type=script&lang=js"
script.render = render

export default script